<template>
  <div>
    <section>
      <div class="row">
        <div class="small-12 columns">
          <h2 class="section-sub-heading">Retirement target</h2>
        </div>
      </div>

      <retirement-target-inputs></retirement-target-inputs>
    </section>
    <div v-if="!hideNav">
      <hr />
      <div class="page-actions">
        <router-link class="button" :to="{name: 'about.super'}">&larr; Back</router-link>
        <router-link class="button results" :to="{name: 'results.contributions'}">Results &rarr;</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['hide-nav'],
  components: {
    RetirementTargetInputs: require('../../inputs/RetirementTargetInputs').default,
  },
};
</script>
